import Vue from 'vue';
import VueRouter from 'vue-router';
import AppHome from '../views/Home.vue';
import AppImpressum from '../views/Impressum.vue';
import AppKi from '../views/Ki.vue';
import AppDevOps from '../views/DevOps.vue';
import AppServices from '../views/Services.vue';
import AppTechnology from '../views/Technology.vue';
import AppNews from '../views/News.vue';
import AppPreise from '../views/Preise.vue';
import AppIntro from '../views/Intro.vue';
import AppDevelopment from '../views/Development.vue';
import AppContact from '../views/Contact.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppHome,
    meta: { 
      title: 'Jens Trompler IT Consulting - KI & DevOps Lösungen'
    }
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: AppImpressum,
    meta: { 
      title: 'Impressum - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/ki',
    name: 'Ki',
    component: AppKi,
    meta: { 
      title: 'KI-Lösungen - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/devops',
    name: 'DevOps',
    component: AppDevOps,
    meta: { 
      title: 'DevOps Transformation - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: AppServices,
    meta: { 
      title: 'Unsere Leistungen - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/technology',
    name: 'Technology',
    component: AppTechnology,
    meta: { 
      title: 'Technologiestack - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: AppNews,
    meta: { 
      title: 'Aktuelles & Erfolgsgeschichten - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/preise',
    name: 'Preise',
    component: AppPreise,
    meta: { 
      title: 'Preise & Leistungen - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/intro',
    name: 'Intro',
    component: AppIntro,
    meta: { 
      title: 'Über uns - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/development',
    name: 'Development',
    component: AppDevelopment,
    meta: { 
      title: 'Software-Entwicklung - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: AppContact,
    meta: { 
      title: 'Kontakt - Jens Trompler IT Consulting'
    }
  },
  {
    path: '/danke',
    name: 'Danke',
    component: AppContact,
    meta: { 
      title: 'Vielen Dank für Ihre Nachricht - Jens Trompler IT Consulting',
      showThankYouMessage: true
    }
  },
  // Redirects
  {
    path: '/views/Ki',
    redirect: '/ki'
  },
  {
    path: '/views/DevOps',
    redirect: '/devops'
  },
  // 404 page
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: { 
      title: 'Seite nicht gefunden - Jens Trompler IT Consulting'
    }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      };
    }
    return { x: 0, y: 0 };
  }
});

// Title updater middleware
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else {
    document.title = 'Jens Trompler IT Consulting';
  }
  
  next();
});

export default router;
